var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrypto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E5E2EB",
    cx: 65,
    cy: 65,
    r: 65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72 26.292c-21.751 0-39.428 17.677-39.428 39.428 0 21.752 17.677 39.449 39.428 39.449 21.752 0 39.449-17.697 39.449-39.449 0-21.751-17.697-39.428-39.449-39.428zm0 4.93c19.089 0 34.519 15.41 34.519 34.498 0 19.089-15.43 34.519-34.519 34.519-19.088 0-34.498-15.43-34.498-34.519 0-19.088 15.41-34.498 34.498-34.498zm0 4.935c-16.306 0-29.564 13.257-29.564 29.564 0 16.306 13.257 29.589 29.564 29.589 16.307 0 29.589-13.282 29.589-29.589 0-16.306-13.282-29.564-29.589-29.564zm0 4.93c13.643 0 24.654 10.991 24.654 24.634 0 13.642-11.012 24.653-24.654 24.653s-24.634-11.01-24.634-24.653A24.587 24.587 0 0 1 65.72 41.086z",
    fill: "#2F224A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.686 48.438a2.464 2.464 0 0 0-2.421 2.508V53.4H60.81a2.466 2.466 0 0 0-2.475 2.48v19.704a2.464 2.464 0 0 0 2.475 2.475h2.455v2.455c0 3.287 4.93 3.287 4.93 0v-2.908c1.046-.371 2-.944 2.768-1.714a7.453 7.453 0 0 0 2.166-5.243 7.458 7.458 0 0 0-.583-2.874 7.365 7.365 0 0 0-.692-1.251c-.192-.285-.426-.531-.655-.785.232-.257.46-.51.655-.8.265-.392.505-.812.693-1.256a7.47 7.47 0 0 0 .433-1.4c.099-.483.15-.967.15-1.474a7.438 7.438 0 0 0-2.167-5.242c-.765-.765-1.722-1.337-2.768-1.71v-2.912a2.46 2.46 0 0 0-2.509-2.508zm-2.421 9.898h2.456a2.44 2.44 0 0 1 1.747.726 2.44 2.44 0 0 1 .674 2.24c-.033.159-.083.305-.145.452a2.434 2.434 0 0 1-.22.419c-.09.131-.197.253-.309.365a2.541 2.541 0 0 1-.366.309 2.392 2.392 0 0 1-.414.216 2.47 2.47 0 0 1-.457.15c-.16.032-.337.052-.51.052h-2.456v-4.93zm0 9.86h2.456a2.604 2.604 0 0 1 1.381.418c.132.089.254.196.366.308.112.112.219.234.308.366.089.131.16.272.221.418a2.387 2.387 0 0 1 .198.944c0 .696-.28 1.299-.727 1.748-.448.449-1.03.732-1.709.732h-2.494v-4.935z",
    fill: "#E7426B",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.bcafe8df1199ea0479952dc06eafa8e7.svg";
export { ForwardRef as ReactComponent };